module.exports = function(app) {
	"use strict";
	app.controller('pages.employer-change-password', ["$state", "$scope", "session", "sessionData", "$filter", "employerUtility", "services", "brandConfig", "navigation", "coremetrics",
		function ($state, $scope, session, sessionData, $filter, employerUtility, services, brandConfig, navigation, coremetrics) {

		$scope.employer = sessionData.employerInfo.planAdministrator;

		var employerBrand = brandConfig.getSharedBrandCodeFromLeafUBK(sessionData.employerInfo.brandName);
		var employerUsername = sessionData.employerInfo.planAdministrator.loginId;
		if($state.previous.name == 'clients'){
			navigation.data.headerTabs[0].state = 'clients';
		}
            $scope.isMcu = sessionData.basicInfo.role.toLowerCase().indexOf("mcu_admin") >= 0
            var clientSelected = localStorage.getItem('clientSelected');
            if ($scope.isMcu && !clientSelected) {
                if(!clientSelected) {
                    if (navigation.data.headerTabs.length) {
                        navigation.data.headerTabs = [];
                    }

                }
			}
			else if($scope.isMcu && clientSelected){
                if(clientSelected) {
                    if(navigation.data.breadCrumbHome.length){
                        navigation.data.breadCrumbHome = [];
                    }

                }
			}
		$scope.formFields = {};
		$scope.forms = {};

		var formInitialState = function(){
			$scope.formFields.currentPassword = '';
			$scope.formFields.newPassword = '';
			$scope.formFields.confirmPassword = '';
			$scope.submitClicked = false;
			$scope.submissionInProgress = false;
			$scope.hasAtleastOneNumber = false;
			//$scope.hasAtLeastOneAlphabet = false;
			$scope.withinLengthRange = false;
			$scope.hasAtleastOneUpperCase=false;
			$scope.hasAtleastLowerCase=false;
			$scope.hasAtleastOneSpecialChar=false;
			$scope.passwordsNotMatching = false;
			$scope.hasSpace=false;
			$scope.criteriaNotMet = false;
			$scope.passwordsNotMatching = false;
			$scope.currentAndNewSame = false;
			$scope.oldPasswordUsed = false;
			$scope.previousPassword=false;

		};

		formInitialState();

		$scope.sidebar = {
			breadCrumb : {
				primary : {
					title: "Profile",
					state: "profile"
					//headtitle: "profile"+" > "+"Change password for " + $filter('capitalize')($scope.employer.firstName) + " " + $filter('capitalize')($scope.employer.lastName)
				},
				secondary: {
					title: "Change password for " + $filter('capitalize')($scope.employer.firstName) + " " + $filter('capitalize')($scope.employer.lastName)
				}
			}
		};


		$scope.checkPasswordRules = function(){

			var newPasswordValue = $scope.formFields.newPassword;
			$scope.submitClicked = false;

			if(newPasswordValue === ''){
				//$scope.hasAtLeastOneAlphabet = false;
				$scope.hasAtleastOneNumber = false;
				$scope.withinLengthRange = false;
				$scope.hasAtleastOneUpperCase=false;
				$scope.hasAtleastLowerCase=false;
				$scope.hasAtleastOneSpecialChar=false;
				$scope.hasSpace=false;
			}

			// if (newPasswordValue.length > 0 && /[a-zA-Z]/i.test(newPasswordValue)) {
			// 	$scope.hasAtLeastOneAlphabet = true;
			// } else {
			// 	$scope.hasAtLeastOneAlphabet = false;
			// }

			//length
			if(newPasswordValue.length >=12){
				$scope.withinLengthRange = true;
			} else {
				$scope.withinLengthRange = false;
			}
			//upper Case
            $scope.hasAtleastOneUpperCase=hasUpperCase(newPasswordValue);

			//lower Case
			$scope.hasAtleastLowerCase=hasLowerCase(newPasswordValue);

			//Number
			$scope.hasAtleastOneNumber = hasNumber(newPasswordValue);
			

			//Special Character
           $scope.hasAtleastOneSpecialChar=hasSpecialChar(newPasswordValue);

		   //No space
		   $scope.hasSpace = hasSpace(newPasswordValue);


			// if (/\d/.test(newPasswordValue)) {
			// 	$scope.hasAtleastOneNumber = true;
			// } else {
			// 	$scope.hasAtleastOneNumber = false;
			// }

			

			/*if(newPasswordValue.length > 10){
				$scope.changePasswordForm.newPasswordField.$error.maxlength = true;
			}*/
		};


		var hasUpperCase = function(s) {
            return (/[A-Z]/).test(s) ? true : false;
        };

		var hasLowerCase = function(s) {
            return (/[a-z]/).test(s) ? true : false;
        };

		var hasSpecialChar = function(s) {
            return (/[#!@$%^&*()\-_=|;:'",.?`~\\\/\[\]\{\}]/).test(s) && !(/[<>+]/).test(s) ? true : false;
        };

		var hasNumber = function(s) {
            return (/\d/).test(s) ? true : false;
        };

		$scope.overAllPattern = (function() {
			var regexp =/^[a-zA-Z0-9 #!@$%^&*()\-_=|;:\x22\x27,.?`~\\\/\[\]\{\}]+$/;
			return {
				test: function(value) {
					if( $scope.requireTel === false ) {
						return true;
					}
					console.log(regexp.test(value)+""+hasSpace(value))
					return regexp.test(value) && !hasSpace(value);
				}
			};
		})();

		var hasSpace = function(s){
			
				return /\s/g.test(s) ? true : false;
			
		};

		var meetsCriteria = function(){
			//console.log()
			return $scope.hasAtleastOneNumber &&
			$scope.withinLengthRange &&
			$scope.hasAtleastOneUpperCase &&
			$scope.hasAtleastLowerCase &&
			$scope.hasAtleastOneSpecialChar && $scope.hasSpace === false ;
		};

		$scope.currentVsNewPasswordCheck = function(){
			$scope.currentAndNewSame = false;

			var currentPassword = $scope.formFields.currentPassword;
			var newPassword = $scope.formFields.newPassword;

			if((newPassword && currentPassword) && newPassword === currentPassword){
				$scope.currentAndNewSame = true;
			}
		};

	   $scope.checkSamePassword = function(){

			$scope.passwordsNotMatching = false;

			var confirmPassword = $scope.formFields.confirmPassword;
			var newPassword = $scope.formFields.newPassword;

			if((confirmPassword && newPassword) && newPassword !== confirmPassword){
				$scope.passwordsNotMatching = true;
			}
		};

		$scope.submitPasswordChange = function(){

			//All Message flags are set to false on each new submit
			$scope.showSuccessMsg = false;
			$scope.serviceFailure = false;
			$scope.incorrectPassword = false;
			$scope.criteriaNotMet = false;
			$scope.passwordsNotMatching = false;
			$scope.currentAndNewSame = false;
			$scope.oldPasswordUsed = false;
			$scope.previousPassword=false;


			var currentPassword = $scope.formFields.currentPassword;
			var newPassword = $scope.formFields.newPassword;
			var confirmPassword = $scope.formFields.confirmPassword;

			if(newPassword.length >= 6){
				$scope.submitClicked = true;
			}

			if(!meetsCriteria()){
			  $scope.criteriaNotMet = true;
			}

			if(confirmPassword !== newPassword){
				$scope.passwordsNotMatching = true;
			}

			if(newPassword === currentPassword){
				$scope.currentAndNewSame = true;
			}

			if (meetsCriteria() && (confirmPassword === newPassword) && (newPassword !== currentPassword)) {
				coremetrics.elementTag('SUBMIT NEW PASSWORD', 'EMPLOYERS:HOME PAGE:CHANGE PASSWORD');
				$scope.submissionInProgress = true;
				services.rbsmbl.employerChangePassword().postData(employerBrand, employerUsername, currentPassword, newPassword).then(
					function (response) {
						$scope.$watch(function () {
							return response.data.baseMessage;
						}, function () {
							if (response && response.status && response.data.baseMessage.returnCode === 200) {
								if (sessionData.tempPassword) {
									sessionData.tempPassword = false;
									sessionData.tempPasswordAgree = false;
									navigation.update();
									//this is for MCU
									if (sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase() == "mcu_admin") {
										sessionData.basicInfo.temporaryPasswordFlag = false;
										$state.go("clientselection");
									}
									else {
										$state.go("home");
									}

								}
								else {
									coremetrics.finishConversion('EMPLOYERS:PROFILE:CHANGE PASSWORD', 'EMPLOYERS:PROFILE:CHANGE');
									coremetrics.pageviewTag('EMPLOYERS:HOME PAGE:CHANGE PASSWORD', 'EMPLOYERS:HOME PAGE');
									$scope.showSuccessMsg = true;
									formInitialState();
									$scope.forms.changePasswordForm.$setPristine();
									$scope.forms.changePasswordForm.$setUntouched();
								}
							} else {
								//PI found 							
								if (response.data.baseMessage.returnCode === 406) {
									if (response.data.baseMessage.returnCodeDescription == 'PI-FOUND') {
										$scope.submissionInProgress = false;
										$scope.oldPasswordUsed = true;
									} else if (response.data.baseMessage.returnCodeDescription == 'The provided new password was found in the password history for the user'){
										$scope.submissionInProgress = false;
										$scope.previousPassword = true;
									}
								} else {
									$scope.submissionInProgress = false;
									$scope.serviceFailure = true;

								}

							}
						})

					},
					function (error) {
						$scope.submissionInProgress = false;

						if (error.data.payload.status === 'Invalid current password') {
							$scope.incorrectPassword = true;
						}

						$scope.serviceFailure = true;
					}
				);
			}
		};

		$scope.cancel = function(){
			if (sessionData.tempPassword) {
				session.logoutWithRedirect();
			}
			else {
				if($state.previous.name == 'clients'){
					$state.go('clients');
				}
				else {
					$state.go('profile');
				}
			}
		};
	}]);

	return [
		{
			state: "employer-change-password",
			url: "/pa-change-password",
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: "pages.employer-change-password"
				},
				"content@employer-change-password": {
					templateUrl: 'pa-change-password.employerTemplate.html/pages/changePassword/changePassword'
				}
			}
		}
	];
};

